// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3912x","colMin":"styles_colMin__VkhFK"};